package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosBackgroundImage
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColorOpacity
import com.anjuros.website.templates.template6.styles.Template6LinkContactButton
import com.anjuros.website.templates.template6.util.ResKey
import com.anjuros.website.templates.template6.util.Template6CompanyDetails
import com.anjuros.website.templates.template6.util.Template6Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template6ContactSection() {

    Box(
        modifier = Modifier
            .id("contact")
            .fillMaxWidth()
            .position(Position.Relative)
    ) {
        AnjurosBackgroundImage(
            src = "template6_reviews.jpg",
            modifier = Modifier
                .displayIfAtLeast(Breakpoint.LG)
                .fillMaxSize()
                .objectFit(ObjectFit.Cover)
        )
        AnjurosBackgroundImage(
            src = "template6_reviews_mobile.jpg",
            modifier = Modifier
                .displayUntil(Breakpoint.LG)
                .fillMaxSize()
                .objectFit(ObjectFit.Cover)
        )
        // Green overlay
        Box(
            modifier = Modifier
                .fillMaxSize()
                .backgroundImage(
                    linearGradient(
                        Template6Theme.GreenOverlay1.getColorOpacity(),
                        Template6Theme.GreenOverlay2.getColorOpacity(),
                        LinearGradient.Direction.ToBottom
                    )
                )


        )

        val breakpoint = rememberBreakpoint()

        if(breakpoint>=Breakpoint.LG) {
            Row(
                modifier = Modifier
                    .align(Alignment.Center)
                    .fillMaxWidth(80.percent)
                    .padding(topBottom = 40.px)
                    .gap(70.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {

                ContactInfo(modifier = Modifier.fillMaxWidth(40.percent))

                Template6ContactFormSection(modifier = Modifier.fillMaxWidth(60.percent))

            }
        } else {
            Column(
                modifier = Modifier
                    .align(Alignment.Center)
                    .fillMaxWidth(90.percent)
                    .padding(topBottom = 40.px)
                    .gap(40.px),
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                ContactInfo(modifier = Modifier.fillMaxWidth(100.percent))

                Template6ContactFormSection(modifier = Modifier.fillMaxWidth(100.percent))

            }
        }

    }

}
@Composable
private fun ContactInfo(
    modifier: Modifier
) {

    Column(
        modifier = modifier
    ) {

        P(
            attrs = Modifier
                .fontSize(16.px)
                .fontWeight(FontWeight.Bold)
                .color(Template6Theme.Secondary.rgb)
                .letterSpacing(2.px)
                .margin(bottom = 16.px)
                .textTransform(TextTransform.Uppercase)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_CONTACT_SUBTITLE))
        }

        P(
            attrs = Modifier
                .fontSize(48.px)
                .fontWeight(FontWeight.Bold)
                .color(Colors.White)
                .margin(bottom = 24.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_CONTACT_TITLE))
        }

        P(
            attrs = Modifier
                .fontSize(18.px)
                .lineHeight(34.px)
                .color(rgb(225,225,225))
                .margin(bottom = 48.px)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE6_CONTACT_DESCRIPTION))
        }
        Link(
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None),
            path = "tel:${Template6Constants.CLIENTS_PHONE}",

            ) {
            ContactItem(
                modifier = Template6LinkContactButton.toModifier(),
                text = Template6CompanyDetails.CLIENTS_PHONE_INFO,
                icon = "template6_contact1.svg"
            )
        }
        Link(
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None),
            path = "mailto:${Template6Constants.CLIENTS_EMAIL}",

            ) {
            ContactItem(
                modifier = Template6LinkContactButton.toModifier(),
                text = Template6CompanyDetails.CLIENTS_EMAIL_INFO,
                icon = "template6_contact2.svg"
            )
        }

        ContactItem(
            modifier = Modifier.color(Colors.White),
            text =Template6CompanyDetails.CLIENTS_COMPANY_SERVICE_AREA_INFO,
                    icon = "template6_contact3.svg"
        )

        ContactItem(
            modifier = Modifier.color(Colors.White),
            text =Template6CompanyDetails.CLIENTS_COMPANY_OPENING_HOURS,
            icon = "template6_contact4.svg"
        )

    }

}

@Composable
private fun ContactItem(
    modifier: Modifier = Modifier,
    text: CompanyDetailsType,
    icon:String,
) {

    Row(
        modifier = Modifier
            .margin(bottom = 26.px)
            .gap(18.px)
            .alignItems(AlignItems.Center)
    ) {

        Box(
            modifier = Modifier
                .size(48.px)
                .flexShrink(0)
                .backgroundColor(Template6Theme.DarkGrey.rgb)
                .borderRadius(50.percent),
            contentAlignment = Alignment.Center
        ) {

            Image(
                src = icon,
                modifier = Modifier
                    .size(24.px)
            )

        }

        P(
            attrs = modifier
                .fontSize(18.px)
                .margin(0.px)
                .toAttrs()
        ) {
            AnjurosText(text)
        }

    }

}
